import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.string.trim";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getUserCommentList, updateUserComment, getStationGroupList, exportBadCommonet } from '@/api/bairun/stationBaseInfo'; //  此处请自行替换地址

import { getStationBaseInfoList } from '@/api/bairun/stationBaseInfo'; //  此处请自行替换地址

import { GetSaleDetailList } from '@/api/bairun/saleDetail'; //  此处请自行替换地址

import { saveAs } from 'file-saver';
import infoList from '@/mixins/infoList';
import * as DateUtil from '@/utils/date';
import OrderStatusTag from '@/components/orderStatusTag';

var _this;

export default {
  name: 'BairunCommentRecord',
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return DateUtil.formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatTime: function formatTime(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return DateUtil.formatTimeToStr(date, 'MM-dd hh:mm');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    getStationName: function getStationName(id) {
      for (var i = 0; i < _this.stationOptions.length; i++) {
        if (_this.stationOptions[i].ID === id) {
          return _this.stationOptions[i].stationName;
        }
      }

      return '';
    },
    getStationGroupName: function getStationGroupName(stationGroupNo) {
      for (var i = 0; i < _this.stationGroupOptions.length; i++) {
        if (_this.stationGroupOptions[i].stationGroupNo === stationGroupNo) {
          return _this.stationGroupOptions[i].stationGroupName;
        }
      }

      return '';
    }
  },
  components: {
    OrderStatusTag: OrderStatusTag
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getUserCommentList,
      stationOptions: [],
      stationTempOptions: [],
      stationGroupOptions: [],
      searchTagType: '全部',
      searchText: '',
      searchDateTimeType: '今日',
      searchStartTime: '',
      searchEndTime: '',
      unHandelTotal: 0,
      // 差评未处理数量
      dialogVisible: false,
      viewDialogVisible: false,
      endTimePickerOptions: {
        disabledDate: function disabledDate(time) {
          // return ture表示日期不可选
          return !DateUtil.isBeforeMonth(_this.searchStartTime, time.Format('yyyy-MM-dd hh:mm:ss'), 3);
        }
      },
      formData: {
        commentNo: '',
        sellerId: '',
        commentStatus: 0,
        remark: ''
      },
      viewOrder: {}
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var stationOptions, stationGroupOptions;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return getStationBaseInfoList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 2:
                stationOptions = _context3.sent;
                _this3.stationOptions = stationOptions.data.list;
                _context3.next = 6;
                return getStationGroupList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 6:
                stationGroupOptions = _context3.sent;
                _this3.stationGroupOptions = stationGroupOptions.data.list;

                if (_this3.stationGroupOptions.length > 0) {
                  _this3.searchInfo.stationGroupNo = _this3.stationGroupOptions[0].stationGroupNo;
                }

                _this3.onChangeStationGroup();

                _this3.onSearchDateTimeTypeChange();

                _this3.onSubmit();

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    onInputChange: function onInputChange() {
      this.$forceUpdate();
    },
    onChangeStationGroup: function onChangeStationGroup() {
      var _this4 = this;

      this.stationTempOptions = this.stationOptions.filter(function (item) {
        return item.stationGroupNo == _this4.searchInfo.stationGroupNo;
      });

      if (this.stationTempOptions.length === 1) {
        this.searchInfo.stationId = this.stationTempOptions[0].ID;
      }

      this.$forceUpdate();
    },
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.searchInfo.mobile = '';
      this.searchInfo.mainOrderNo = '';
      this.searchInfo.commentStatus = 0;
      this.searchInfo.commentPointType = 9999;
      this.searchInfo.commentTagGoodsType = 9999;

      if (this.searchText !== '' && this.searchText.trim().length === 11) {
        this.searchInfo.mobile = this.searchText.trim();
        this.searchInfo.startTime = ''; // 手机/订单查询不限时间

        this.searchInfo.endTime = ''; // 手机/订单查询不限时间
      }

      if (this.searchText !== '' && this.searchText.trim().length > 11) {
        this.searchInfo.mainOrderNo = this.searchText.trim();
        this.searchInfo.startTime = ''; // 手机/订单查询不限时间

        this.searchInfo.endTime = ''; // 手机/订单查询不限时间
      }

      if (this.searchTagType === '全部') {
        this.searchInfo.commentTagGoodsType = 9999;
      }

      if (this.searchTagType === '好评') {
        this.searchInfo.commentTagGoodsType = 1;
      }

      if (this.searchTagType === '差评') {
        this.searchInfo.commentTagGoodsType = -1;
      }

      if (this.searchTagType.indexOf('差评未处理') > -1) {
        this.searchInfo.commentTagGoodsType = -1;
        this.searchInfo.commentPointType = -1;
        this.searchInfo.commentStatus = 1;
      }

      this.reloadTableData();
    },
    onExport: function onExport() {
      exportBadCommonet({
        stationGroupNo: this.searchInfo.stationGroupNo,
        stationId: this.searchInfo.stationId,
        startTime: this.searchInfo.startTime,
        endTime: this.searchInfo.endTime,
        commentPointType: -1,
        commentTagGoodsType: -1
      }).then(function (res) {
        saveAs(res.data.fileUrl);
      });
    },
    reloadTableData: function reloadTableData() {
      var _this5 = this;

      this.getTableData(this.page, this.pageSize, function (res) {
        _this5.unHandelTotal = res.data.unHandelTotal;
      });
    },
    onSearchDateTimeTypeChange: function onSearchDateTimeTypeChange() {
      console.log('onSearchDateTimeTypeChange');

      if (this.searchDateTimeType === '今日') {
        this.searchInfo.startTime = DateUtil.todayStartStr();
        this.searchInfo.endTime = DateUtil.todayEndStr();
        this.$set(this, 'searchStartTime', this.searchInfo.startTime);
        this.$set(this, 'searchEndTime', this.searchInfo.endTime);
      }

      if (this.searchDateTimeType === '昨日') {
        this.searchInfo.startTime = DateUtil.yesterdayStartStr();
        this.searchInfo.endTime = DateUtil.yesterdayEndStr();
        this.$set(this, 'searchStartTime', this.searchInfo.startTime);
        this.$set(this, 'searchEndTime', this.searchInfo.endTime);
      }

      if (this.searchDateTimeType === '本周') {
        this.searchInfo.startTime = DateUtil.weekStartStr();
        this.searchInfo.endTime = DateUtil.weekEndStr();
        this.$set(this, 'searchStartTime', this.searchInfo.startTime);
        this.$set(this, 'searchEndTime', this.searchInfo.endTime);
      }

      if (this.searchDateTimeType === '本月') {
        this.searchInfo.startTime = DateUtil.monthStartStr();
        this.searchInfo.endTime = DateUtil.monthEndStr();
        this.$set(this, 'searchStartTime', this.searchInfo.startTime);
        this.$set(this, 'searchEndTime', this.searchInfo.endTime);
      }

      if (this.searchDateTimeType === '本季') {
        this.searchInfo.startTime = DateUtil.quarterStartStr();
        this.searchInfo.endTime = DateUtil.quarterEndStr();
        this.$set(this, 'searchStartTime', this.searchInfo.startTime);
        this.$set(this, 'searchEndTime', this.searchInfo.endTime);
      }
    },
    onCustomDateTimeChange: function onCustomDateTimeChange() {
      console.log('onCustomDateTimeChange'); // 如果开始日期不在n个月范围内，则清空结束日期

      if (this.searchStartTime !== '' && !DateUtil.isBeforeMonth(this.searchStartTime, this.searchEndTime, 3)) {
        this.$set(this, 'searchEndTime', '');
      }

      if (this.searchStartTime != '' && this.searchEndTime != '') {
        this.searchDateTimeType = '';
        this.searchInfo.startTime = this.searchStartTime;
        this.searchInfo.endTime = this.searchEndTime;
      }
    },
    onRemark: function onRemark(row) {
      this.dialogVisible = true;
      this.formData.commentNo = row.commentNo;
      this.formData.sellerId = row.sellerId;
      this.formData.remark = row.remark;
    },
    onViewOrder: function onViewOrder(mainOrderNo) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                params = {
                  mainOrderNo: mainOrderNo,
                  sellerOrderType: 1,
                  page: 1,
                  pageSize: 1
                };
                _context4.next = 3;
                return GetSaleDetailList(params);

              case 3:
                res = _context4.sent;

                if (!(res.code !== 0 || !res.data.list || !res.data.list.length)) {
                  _context4.next = 7;
                  break;
                }

                _this6.$message({
                  type: 'error',
                  message: res.msg
                });

                return _context4.abrupt("return");

              case 7:
                _this6.viewOrder = res.data.list[0];
                _this6.viewDialogVisible = true;

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    closeDialog: function closeDialog() {
      this.dialogVisible = false;
      this.viewdialogVisible = false;
      this.viewOrder = {};
      this.formData = {
        commentNo: '',
        sellerId: '',
        commentStatus: 0,
        remark: ''
      };
    },
    enterDialog: function enterDialog() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(_this7.formData.remark.trim() === '')) {
                  _context5.next = 3;
                  break;
                }

                _this7.$message({
                  type: 'error',
                  message: '请备注好处理结果'
                });

                return _context5.abrupt("return");

              case 3:
                _context5.next = 5;
                return updateUserComment({
                  commentNo: _this7.formData.commentNo,
                  sellerId: _this7.formData.sellerId,
                  commentStatus: 2,
                  remark: _this7.formData.remark
                });

              case 5:
                res = _context5.sent;

                _this7.enterDialogRepose(res);

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    enterDialogRepose: function enterDialogRepose(res) {
      if (res.code === 0) {
        this.$message({
          type: 'success',
          message: '操作成功'
        });
        this.closeDialog();
        this.reloadTableData();
      }
    }
  }
};